import { render, staticRenderFns } from "./charter-flight.vue?vue&type=template&id=ea48795e&"
import script from "./charter-flight.vue?vue&type=script&lang=js&"
export * from "./charter-flight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports